<template>
  <div>
    <el-form ref="form" :model="info" label-width="120px" size="medium" style="width: 800px;padding-left: 30px;">
      <div class="adv-l">
        <span style="font-size: 25px; font-weight: bold">落地页配置</span>
      </div>
      <el-form-item label="小程序名称：">
        <el-input placeholder="请输入小程序名称" v-model="info.Name"></el-input>
      </el-form-item>
      <el-form-item label="背景图：">
        <el-upload class="upload-demo"
                   action="https://jsonplaceholder.typicode.com/posts/"
                   :on-remove="handleRemove"
                   :on-change="handleImg"
                   :file-list="uploadImgPath"
                   :limit = '1'
                   list-type="picture"
                   :auto-upload="false"

                   ref="img"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="按钮：">
        <el-upload class="upload-demo"
                   action="https://jsonplaceholder.typicode.com/posts/"
                   :on-remove="handleBtnRemove"
                   :on-change="handleBtnImg"
                   :file-list="uploadBtnImgPath"
                   :limit = '1'
                   list-type="picture"
                   :auto-upload="false"
                   ref="img"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持png和gif</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="小程序原始id：">
        <el-input placeholder="小程序对应的以gh_开头的ID" v-model="info.MiniAppId"></el-input>
      </el-form-item>
      <el-form-item label="路径：">
        <el-input placeholder="所需跳转的小程序内页面路径及参数" v-model="info.Url"></el-input>
        <div>注：例如小程序中路径地址为： pages/login/index,   则填入到此配置中时需加上
          <span style="color: red;padding-right: 5px; padding-left: 5px;">.html</span>,  最终填入路径为：pages/login/index.html</div>
        <div>例如小程序中路径地址为： pages/login/index.html,   需要加上体重参数
          <span style="color: red;padding-right: 5px; padding-left: 5px;">?weight=</span>,并且保证体重参数在最后  最终填入路径为：pages/login/index.html?weight=</div>
      </el-form-item>
      <div class="adv-l">
        <span style="font-size: 25px; font-weight: bold">选择公众号</span>
        <span style="font-weight: 20px;padding-left: 30px; flex: 1">仅在关注下列公众号时推小程序</span>
        <el-button type="primary" @click="advDialogVisible = true">添加</el-button>
      </div>
      <div class="adv-list">
        <el-tag
            style="margin-right: 20px;"
            v-for="(tag, index) in selectAdv"
            :key="tag.WeChatName"
            closable
            @close="advClose(index)"
            type="warning">
          {{tag.WeChatName}}
        </el-tag>
      </div>
      <div class="adv-l">
        <span style="font-size: 25px; font-weight: bold">使用配置</span>
      </div>
      <el-form-item label="用户性别限制：">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedSex" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="sex in genders" :label="sex.value" :key="sex.value">{{sex.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="有效时间：">
        <el-date-picker
            v-model="time"
            @change="timeChange"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="监控阈值：">
        <el-input placeholder="连续N个用户点击按钮未正常打开小程序则自动禁用" v-model="info.WarningCount"></el-input>
      </el-form-item>
<!--      <el-form-item label="重粉直接导小程序开关：">-->
<!--        <el-switch-->
<!--            v-model="info.JunkStatus"-->
<!--            active-value="1"-->
<!--            inactive-value="0"-->
<!--            active-color="#13ce66"-->
<!--            inactive-color="#ff4949">-->
<!--        </el-switch>-->
<!--        <span>开启即为直接小程序导粉</span>-->
<!--      </el-form-item>-->
      <el-form-item label="排序：">
        <el-input placeholder="数字越大排序越高" v-model="info.Sort"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="info.Status" placeholder="启用">
          <el-option
              v-for="(item, index) in statusOptions"
              :key="index"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="margin-top: 50px;" @click="add">保存配置</el-button>
      </el-form-item>
    </el-form>
    <select-adv-dialog
        :accountIds="selectAdv"
        :visible.sync="advDialogVisible"
        @onSelect="handleChooseAd">
    </select-adv-dialog>
  </div>
</template>
<script>
import * as AdApi from '@/api/ad'
import AccountApi from '@/api/Account'
import SelectAdvDialog from '@/components/dialog/select-adv-dialog'

export default {
  name: 'h5PushXcxConfig',
  mixins: ['mixin'],
  data() {
    return {
      id: '',
      info: null,
      uploadImgPath: [],
      uploadImgRealObject: null,

      uploadBtnImgPath: [],
      uploadBtnImgRealObject: null,
      isListLoading: false,
      statusOptions: [
        { label: '启用', value: '1' },
        { label: '禁用', value: '0' }],
      genders: [
        { name: '男', value: '1' },
        { name: '女', value: '2' },
        { name: '未知', value: '0' }
      ],
      adId: '',
      isUploadImg: false, // 是否要上传图片
      uploadedImgUrl: '', // 已经上传图片地址
      isUploadBtnImg: false, // 是否要上传图片
      uploadedBtnImgUrl: '', // 已经上传图片地址
      time: '',
      selectAdv: '',
      advDialogVisible: false,
      checkAll: true,
      isIndeterminate: false,
      checkedSex: []
    }
  },
  components: {
    SelectAdvDialog
  },
  computed: {

  },

  mounted() {
    // this.genders.forEach(item => {
    //   this.checkedSex.push(item.value)
    // })
  },
  activated() {
    var id = this.$route.query.id
    if (id != this.id) {
      this.id = id
      this.getAdInfo()
    }
  },
  methods: {
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedSex = []
      if (val) {
        this.genders.forEach(item => {
          this.checkedSex.push(item.value)
        })
      }

      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      console.log(value)
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.genders.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.genders.length;
    },
    advClose(index) {
      console.log(index)
      this.selectAdv.splice(index, 1)
      console.log(this.selectAdv)
    },
    handleChooseAd(val) {
      console.log(val)
      this.selectAdv = val
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.isUploadImg = true
    },
    handleImg(file, fileList) {
      console.log('handleImg', file, fileList, this.$refs.img)
      this.uploadImgPath = fileList
      if (fileList.length > 0) {
        this.uploadImgRealObject = file.raw
        this.isUploadImg = true
      } else {
        this.uploadImgRealObject = null
      }
    },
    handleBtnRemove(file, fileList) {
      console.log(file, fileList)
      this.isUploadBtnImg = true
    },
    handleBtnImg(file, fileList) {
      console.log('handleImg', file, fileList, this.$refs.img)
      this.uploadBtnImgPath = fileList
      if (fileList.length > 0) {
        this.uploadBtnImgRealObject = file.raw
        this.isUploadBtnImg = true
      } else {
        this.uploadBtnImgRealObject = null
      }
    },
    timeChange(e) {
      console.log(e)

      if (e) {
        this.info.StartTime = e[0]
        this.info.EndTime = e[1]
        this.time = [new Date(this.info.StartTime), new Date(this.info.EndTime)]
      } else {
        this.info.StartTime = ''
        this.info.EndTime = ''
        this.time = []
      }
    },
    getAdInfo() {
      AdApi.getShowApplets({ Id: this.id }).then(({ data }) => {
        if (data.Status === 200) {
          this.info = data.Result ? data.Result : {}
          if (data.Result) {
            this.info.JunkStatus = this.info.JunkStatus.toString()
            this.selectAdv = this.info.AdvInfo
            this.uploadImgPath.push({ url: this.info.BgImg })
            this.uploadBtnImgPath.push({ url: this.info.ButtonImg })
            this.time = [new Date(this.info.StartTime), new Date(this.info.EndTime)]
            console.log(this.info, this.info.Sex)
            if (this.info.Sex) {
              this.info.Sex = this.info.Sex.toString()
              this.checkedSex = this.info.Sex.split(',')
            } else {
              this.genders.forEach(item => {
                this.checkedSex.push(item.value)
              })
            }
            console.log(this.checkedSex, this.info, this.info.Sex)
            if (this.checkedSex.length === this.genders.length) {
              this.checkAll = true
              this.isIndeterminate = false
            } else {
              this.checkAll = false
              this.isIndeterminate = true
            }
          }
        } else {
          this.$notify({
            title: '警告',
            message: data.Result.ErrorMsg,
            type: 'fail',
            duration: 2000
          })
        }
      })
    },
    add() {
      console.log(this.uploadImgPath)
      if (this.isUploadImg && this.uploadImgRealObject == null) {
        this.$notify({
          title: '警告',
          message: '背景图不能为空',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.isUploadBtnImg && this.uploadBtnImgRealObject == null) {
        this.$notify({
          title: '警告',
          message: '按钮图不能为空',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.info.MiniAppId.length <= 0) {
        this.$notify({
          title: '警告',
          message: '小程序原始ID不能为空',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.info.Url.length <= 0) {
        this.$notify({
          title: '警告',
          message: '小程序路径不能为空',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.selectAdv.length <= 0) {
        this.$notify({
          title: '警告',
          message: '请选择公众号',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.info.StartTime.length <= 0) {
        this.$notify({
          title: '警告',
          message: '请选择有效时间',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.info.WarningCount.length <= 0) {
        this.$notify({
          title: '警告',
          message: '请输入预警阈值',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.info.Status.length <= 0) {
        this.$notify({
          title: '警告',
          message: '请选择状态',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.checkedSex.length <= 0) {
        this.$notify({
          title: '警告',
          message: '请选择至少一个性别',
          type: 'fail',
          duration: 2000
        })
        return
      }
      if (this.isUploadImg) {
        this.uploadImg()
      } else if (this.isUploadBtnImg) {
        this.uploadBtnImg()
      } else {
        this.uploadInfo()
      }
    },
    // 添加或者修改广告
    uploadInfo() {
      var appids = []
      this.selectAdv.forEach(item => {
        appids.push(item.Id)
      })
      this.info.AppIds = appids.join(',')
      this.info.Sex = this.checkedSex.join(',')
      console.log(this.info)
      AdApi.storeApplets(this.info).then(({ data }) => {
        if (data.Status === 200) {
          this.$notify({
            title: '提示',
            message: this.adId ? '修改成功' : '添加成功',
            type: 'success',
            duration: 2000
          })
          this.$router.push({ path: 'h5PushXcxConfigList', query: { force: 1 }})
        } else {
          this.$notify({
            title: '提示',
            message: data.Result.ErrorMsg,
            type: 'failed',
            duration: 2000
          })
        }
      })
    },
    uploadImg() {
      var formData = new FormData()
      console.log('video update1', this.uploadImgRealObject)
      // 上传视频
      console.log('video update')
      formData.append('pic', this.uploadImgRealObject)
      // formData.append("pic", this.uploadVideoRealObject);
      AccountApi.uploadImage(formData).then(({ data }) => {
        console.log(data)
        if (data.Status === 200) {
          this.info.BgImg = data.Result.url
          this.isUploadImg = false
          this.add()
        } else {
          this.$notify({
            title: '提示',
            message: data.Result.ErrorMsg,
            type: 'failed',
            duration: 2000
          })
        }
      })
    },
    uploadBtnImg() {
      var formData = new FormData()
      // 上传视频
      console.log('video update')
      formData.append('pic', this.uploadBtnImgRealObject)
      // formData.append("pic", this.uploadVideoRealObject);
      AccountApi.uploadImage(formData).then(({ data }) => {
        console.log(data)
        if (data.Status === 200) {
          this.info.ButtonImg = data.Result.url
          this.isUploadBtnImg = false
          this.add()
        } else {
          this.$notify({
            title: '提示',
            message: data.Result.ErrorMsg,
            type: 'failed',
            duration: 2000
          })
        }
      })
    }
  }
}

</script>
<style lang="less" scoped>
.adv-l {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f4f4f4;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.adv-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px;
  padding-left: 100px;
}
</style>
